import React, { Component } from 'react';
import CommerceGlobeLogo from '../../../public/images/brand/globe_logo.png';
import CommerceConnectionsLogo from '../../../public/images/brand/commerce_connections.png';
import FinemarkLogo from '../../../public/images/brand/FineMark_Logo.svg';
import Spinner from 'react-tiny-spin';
import { request } from '../../common/globals/requestStore';
import ErrorText from './ErrorText';
import FingerPrint from '../../../public/javascript/lib/finger-print.js';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { ACKNOWLEDGEMENT_CHECKED_KEY, getDaysAgoAtMidnight, getFraudAcknowledgementThreshold } from '../utils/helpers';
import ProtectCredentialsSection from './ProtectCredentialsSection';
import Typography from '@mui/material/Typography';
import styles from './styles';

const spinnerConfig = {
    lines: 13 // The number of lines to draw
    , length: 24 // The length of each line
    , width: 8 // The line thickness
    , radius: 30 // The radius of the inner circle
    , scale: .25 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    , color: '#ffffff' // #rgb or #rrggbb or array of colors
    , opacity: 0.25 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '50%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'absolute' // Element positioning
};

class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            custId: '',
            userName: '',
            secret: '',
            submitting: false,
            isError: false,
            isCapsLockOn: false,
            showPass: false,
            errorMessage: '',
            acknowledgedPolicy: false,
            hideAcknowledgeCheckbox: false
        };
        this._passRef = React.createRef()
        this.login = this.login.bind(this)
        this.keyDown = this.keyDown.bind(this)
        this.toggleShowPass = this.toggleShowPass.bind(this);
        this.toggleIsPolicyAcknowledged = this.toggleIsPolicyAcknowledged.bind(this);
        this.handleChange = this.handleChange.bind(this)
    }

    toggleShowPass() {
        const { showPass } = this.state
        if(showPass)
            this._passRef.current.type = 'password'
        else
            this._passRef.current.type = 'text'
        this.setState({showPass: !showPass})
    }

    handleChange(input, e) {
        this.setState({[input]: e.target.value, isError: false})
    }

    keyDown = (i, e) => {
        let code = e.keyCode || e.which
        let btnDisabled
        this.state.custId !== '' && this.state.userName !== '' && this.state.secret !== '' && this.state.acknowledgedPolicy ? btnDisabled = false : btnDisabled = true
        if (i === 2)
            this.setState({isCapsLockOn: e.getModifierState("CapsLock")})

        if(code === 13 && !btnDisabled) {
            this.login()
        }
    }

    login() {
        this.setState({submitting: true})
        let params = {
            businessCode: this.state.custId,
            userName: this.state.userName,
            secret: this.state.secret,
        }

        getAppStatusIfNecessary(() => {
            if (LOGIN_APP === appCodeType.cmp || getUrlParams()['legacyLogin'] === 'true') {
                let loginForm = document.getElementById("loginForm")
                loginForm.submit();
            }
            else {
                request
                    .post(LoginUrl)
                    .type('json')
                    .send({credentials: params, isFinemark: this.props.isFinemark})
                    .set({
                        'Fingerprint-Device-Print': FingerPrint.fingerprint_deviceprint(),
                        'FingerPrint-Language': FingerPrint.fingerprint_language(),
                        'FingerPrint-Time-Zone': FingerPrint.fingerprint_timezone()
                    })
                    .end((err, res) => {
                        if (res.body.success) window.location.href = window.location.origin + res.body.url;
                        else {
                            this.displayErrorMessage(res.body.code);
                        }
                    })
            }
        })
    }

    displayErrorMessage(code){
        let errorMsg = '';
        switch(code){
            case 0:
                break;
            case 1:
                errorMsg =  "Invalid user name or authentication credential(s). Please try again.";
                break;
            case 2:
                window.location.href = window.location.origin + "/eci/passwordReset?status=1";
                break;
            case 3:
                window.location.href = window.location.origin + "/eci/passwordReset?status=2";
                break;
            case 4:
                errorMsg = "You previously exceeded the maximum number of attempts to answer your security questions. Please contact Commercial Customer Support at 800-207-0886.";
                break;
            case 5:
                errorMsg = "Your account is locked. Please contact Commercial Customer Support at 800-207-0886.";
                break;
            case 11:
                errorMsg = "We are unable to process your request at this time. Please contact Commercial Customer Support at 800-207-0886 for assistance.";
                break;
            case 12:
                errorMsg = "Due to inactivity, your account is not available. Please contact Commercial Customer Support at 800-207-0886 for assistance.";
                break;
            default:
                errorMsg = "Invalid user name or authentication credential(s). Please try again.";
        }
        this.setState({errorMessage : errorMsg, secret: '', isError : true, submitting: false})
    }

    toggleIsPolicyAcknowledged() {
        this.setState((prevState) => {
            return {
                acknowledgedPolicy: !prevState.acknowledgedPolicy
            }
        }, () => {
            try {
                if (this.state.acknowledgedPolicy) window.localStorage.setItem(ACKNOWLEDGEMENT_CHECKED_KEY, String(Date.now()))
                else window.localStorage.removeItem(ACKNOWLEDGEMENT_CHECKED_KEY)
            } catch (err) {
                console.warn("Failed to persist acknowledgement", err)
            }

        })
    }

    async componentDidMount() {
        this.nameInput.focus()

        const fraudAckTimeframe = await getFraudAcknowledgementThreshold()
        const daysAgoAtMidnight = getDaysAgoAtMidnight(fraudAckTimeframe)
        const storedLastChecked = window.localStorage.getItem(ACKNOWLEDGEMENT_CHECKED_KEY)
        if (storedLastChecked) {
            const ms = Number(storedLastChecked)
            if (Number.isFinite(ms)) {
                const lastChecked = new Date(ms)

                if (lastChecked > daysAgoAtMidnight) {
                    this.setState({acknowledgedPolicy: true})
                    this.setState({hideAcknowledgeCheckbox: true})
                }
            }
        }
    }

    render() {
        const { isFinemark } = this.props;

        return (
            <div id="header" className="cc-center-card">
                <div id="loginContent" className="cb-col-lg-5 cb-col-md-7 cb-col-sm-10 cb-col-xs-12">
                    <div className="cb-card">
                        <div className="cb-card-title cc-card-title">
                            { isFinemark
                                    ? <img id="fmLogo" src={FinemarkLogo} alt="Finemark Logo"/>
                                    : (
                                        <>
                                            <img id="commerceGlobeLogo" src={CommerceGlobeLogo} alt="Commerce Globe Logo"/>
                                            <img id="commerceConnectionsLogo" src={CommerceConnectionsLogo} alt="Commerce Connections Logo"/>
                                        </>
                                    )
                            }
                        </div>
                        <div id="loginInputs" className="cb-card-block">
                            <form name="loginForm" id="loginForm" method="POST" action="/cb/servlet/cb/jsp-ns/login2.jsp">
                                { isFinemark && (
                                    <Typography variant='body1' sx={styles.message}>
                                        Upon successful login, your account will be displayed under the Commerce Bank brand.
                                    </Typography>
                                )}
                                <div className="cb-form-group">
                                    <div className='cb-input-group'>
                                        <label className="cb-form-control-label" htmlFor="CustomerID">Customer ID</label>
                                        <input
                                            ref={ (input) => {this.nameInput = input}}
                                            type="text"
                                            className='cb-form-control'
                                            tabIndex={1}
                                            name="CustomerID"
                                            id="CustomerID"
                                            value={this.state.custId}
                                            maxLength="24"
                                            autoComplete="off"
                                            onChange={(e) => {this.handleChange('custId', e)}}
                                            onKeyDown={this.keyDown.bind(this, 0)}
                                        />
                                    </div>
                                </div>
                                <div className="cb-form-group">
                                    <div className='cb-input-group'>
                                        <label className="cb-form-control-label" htmlFor="UserName">User ID</label>
                                        <input
                                            type="text"
                                            className='cb-form-control'
                                            tabIndex={2}
                                            name="UserName"
                                            id="UserName"
                                            maxLength="24"
                                            value={this.state.userName}
                                            autoComplete="off"
                                            onChange={(e) => {this.handleChange('userName', e)}}
                                            onKeyDown={this.keyDown.bind(this, 1)}
                                        />
                                    </div>
                                </div>
                                <div className="cb-form-group">
                                    <div className={`cb-input-group ${this.state.isCapsLockOn ? 'cb-has-warning' : null}`}>
                                        <label className="cb-form-control-label" htmlFor="Password">Password</label>
                                        <input
                                            type="password"
                                            className={`cb-form-control ${this.state.isCapsLockOn ? 'input-warning' : null}`}
                                            tabIndex={3}
                                            name="Password"
                                            id="Password"
                                            value={this.state.secret}
                                            ref={this._passRef}
                                            maxLength="16"
                                            onChange={(e) => {this.handleChange('secret', e)}}
                                            onKeyDown={this.keyDown.bind(this, 2)}
                                        />
                                        <span className="pass-icon" onClick={() => this.toggleShowPass()}>
                                            { this.state.showPass ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </span>
                                        {this.state.isCapsLockOn
                                        && <div className="cb-form-control-feedback">
                                            <i className="cb-icon icon-warning"/> Caps Lock On
                                        </div>
                                        }
                                    </div>
                                </div>
                                { this.state.isError
                                    ? (
                                        <div style={{ marginBottom: '1rem', }}>
                                            <ErrorText dialogContentText={this.state.errorMessage}/>
                                        </div>
                                    )
                                    : null
                                }
                                <ProtectCredentialsSection hideAcknowledgeCheckbox={this.state.hideAcknowledgeCheckbox}
                                                           acknowledgedPolicy={this.state.acknowledgedPolicy}
                                                           onAckChecked={this.toggleIsPolicyAcknowledged}
                                                           isFinemark={isFinemark}
                                />
                                <div className="cb-input-group cb-center">
                                    <button type="button"
                                            name="submitButtonName"
                                            id="submitButtonName"
                                            className={`${isFinemark ? 'submit-btn-fm' : 'submit-btn'} cb-btn cb-btn-primary`}
                                            disabled={!(this.state.custId !== '' && this.state.userName !== '' && this.state.secret !== '' && this.state.acknowledgedPolicy) || this.state.submitting}
                                            onClick={this.login}
                                    >
                                        { this.state.submitting ? <Spinner config={spinnerConfig} /> : "Log In" }
                                    </button>
                                </div>
                                <div className="cb-text-md-center" id="passwordReset">
                                    <a href='/eci/passwordReset' className={isFinemark && 'pw-reset-fm'} style={{fontWeight: 'bold', fontSize: '16px'}}>Forgot Your Password?</a>
                                </div>
                            </form>
                            {isFinemark && (
                              <Typography sx={{ marginTop: { xs:'8px', md:'12px', lg:'16px' } }}>Need help? Contact us at 877-461-5901.</Typography>
                            )}
                        </div>
                    </div>
                </div>
                <div id="systemMessageContent"></div>
            </div>

        )

    }
}

export default Main;